import React, { useEffect } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

export const ReportErrorDialog = (props) => {

    const {reportError, setReportError} = props

    useEffect(() => {
        let timeoutId;
        if (reportError) {
            timeoutId = setTimeout(() => {
                setReportError(false)
            }, 2000);
        }
        return () => {
            clearTimeout(timeoutId)

        };
    }, [reportError,setReportError]);

    return (
        <dialog
            className="dialog--temporary"
            open={reportError}
            onClose={()=>setReportError(false)}
        >
            <div className="dialog__row-container">
                <header>
                    <h2>
                    Erro ao carregar o comprovante de assinatura
                    </h2>
                </header>
                <IconButton 
                    onClick={()=>setReportError(false)}
                >
                    <CloseIcon />
                </IconButton>
            </div>
        </dialog>
    );
}